import {Box} from '@mui/material';
import React from 'react';

const CustomContentWrapper = (props: any) => {
    return (
        <Box p={2}>
            {props.children}
        </Box>
    );
};

export default CustomContentWrapper;